module.exports = __webpack_public_path__ + "static/media/592.0d152187.webp";